module.exports = __webpack_public_path__ + "assets/img/img-label-back.dd5ed60a.png";